import isEmpty from 'lodash/isEmpty';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_QUOTES } from 'lib/quoteBind/queryKeys';
// app
import { enqueueNotification } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const usePutQuoteRates = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.queries.usePutQuoteRates',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = async (res) => {
    dispatch(enqueueNotification('notification.putQuoteRates.success', 'success'));
    queryClient.setQueryData([QB_RISK_QUOTES, { id: res?.riskId }], (oldData) =>
      oldData?.map((quote) => {
        if (quote.id === res?.id) {
          return res;
        }
        return quote;
      })
    );
    queryClient.invalidateQueries([QB_RISK_QUOTES, { id: res?.riskId }]);
  };

  return useMutation(
    async ({ commissionRates, quoteID }) => {
      if (isEmpty(commissionRates) || !quoteID) {
        throw new Error('Invalid data');
      }

      const path = `quotes/${quoteID}/rates`;

      const result = await quoteBindAxios.put(path, commissionRates);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
